import { create } from "zustand";
import { IMemberWidgetSchema } from "../api/types";

export interface MemberWidgetStore {
  postModel: IMemberWidgetSchema;
  handleFiltering: (filterModel: IMemberWidgetSchema) => void;
}

const useMemberWidgetStore = create<MemberWidgetStore>()((set) => ({
  postModel: {
    filterOptions: 2,
  },

  handleFiltering: (filterModel: IMemberWidgetSchema) =>
    set((state) => ({ postModel: { ...state.postModel, ...filterModel } })),
}));

export default useMemberWidgetStore;
